import { createClasses } from '../../../theme/createClasses';

// ----------------------------------------------------------------------

export const uploadClasses = {
  upload: createClasses('upload'),
  uploadBox: createClasses('upload__box'),
  uploadAvatar: createClasses('upload__avatar'),
  uploadSinglePreview: createClasses('upload__single__preview'),
  uploadMultiPreview: createClasses('upload__multi__preview'),
  uploadRejectionFiles: createClasses('upload__rejection__files'),
};

export const fileThumbnailClasses = {
  root: createClasses('file__thumbnail__root'),
  img: createClasses('file__thumbnail__img'),
  icon: createClasses('file__thumbnail__icon'),
  removeBtn: createClasses('file__thumbnail__remove__button'),
  downloadBtn: createClasses('file__thumbnail__download__button'),
};
